module.exports = __webpack_public_path__ + "static/media/SCDS2021-ProgramBook_Abstract.edc38ba8.pdf";